import { noop } from 'rxjs';
import { NULL_SERVICE, Service } from '../base/service';

export interface LinkService extends Service {
  readonly selectedText: string;
  readonly url?: string;

  setUrl(url: string | undefined): void;
}

export const NULL_LINK_SERVICE: LinkService = {
  ...NULL_SERVICE,
  selectedText: '',
  url: undefined,
  setUrl: noop,
};
